'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeRuntime = initializeRuntime;
exports.runtime = runtime;

var _compilerState = require('./compilerState');

var _imports = require('./imports');

var runtimeMethods = {
  'isMatch': true,
  'hasLength': true,
  'hasProps': true
};

function initializeRuntime() {
  return {
    imports: (0, _imports.createImports)(),
    symbols: {}
  };
}function runtime(method) {
  if (!runtimeMethods[method]) {
    throw new Error(`Invalid runtime method ${method}. This is an internal error.`);
  }
  var _getCompilerState = (0, _compilerState.getCompilerState)(),
      _getCompilerState$run = _getCompilerState.runtime,
      symbols = _getCompilerState$run.symbols,
      imports = _getCompilerState$run.imports,
      programPath = _getCompilerState.programPath;

  if (!symbols[method]) {
    symbols[method] = programPath.scope.generateUidIdentifier(method);
    (0, _imports.addImport)(imports, "@oigroup/lightscript-runtime/" + method, symbols[method].name);
  }return symbols[method];
}